import React from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import NewsWithImage from "../../molecules/NewsWithImage";
import ComponentContainer from "../../layouts/component-container";

import "./nineStories.m.css";

const NineStories = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [] } = collection;
  const stories = items.filter(({ type }) => type === "story");

  if (!stories.length) return null;

  const [firstStory] = stories;

  return (
    <ComponentContainer styleName="base" className="nine-stories" collection={collection}>
      <div className="nine-stories">
        {stories.length > 1 && <Organism1 stories={stories.slice(1, 4)} className="left-storycards" />}
        {firstStory && (
          <NewsWithImage
            styleName="center-card"
            story={firstStory.story}
            cssStyleName="semiBigSize"
            showExcerpt={true}
            widths={[360, 270, 420]}
          />
        )}
        {stories.length > 4 && <Organism1 stories={stories.slice(4, 7)} className="right-storycards" />}
      </div>
    </ComponentContainer>
  );
};

NineStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

NineStories.storyLimit = 7;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(NineStories);
